import * as React from "react";

function SvgProductBird(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="15 15 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.92 51.911c-7.027 7.605-6.878 19.661.447 27.127 3.576 3.656 8.327 5.672 13.39 5.676h.018c5.073 0 9.842-2.017 13.435-5.675 7.457-7.602 7.443-19.965-.03-27.556L57.852 40.93c-1.045 8.584-4.264 16.116-9.998 16.116-1.757 0-4.62-.782-6.934-5.136zm13.855 39.72h-.025c-6.937-.008-13.446-2.757-18.325-7.754-10.078-10.272-10.092-26.986-.031-37.24l3.4-3.437a3.495 3.495 0 013.36-.903A3.46 3.46 0 0145.6 44.77c.795 3.074 1.743 4.586 2.265 5.16 1.228-1.294 3.448-6.52 3.448-15.362 0-.509 0-.99-.028-1.47a3.46 3.46 0 011.065-2.725c1.373-1.304 3.573-1.304 4.89.052L73.114 46.64c10.099 10.25 10.116 26.964.035 37.24-4.908 5-11.43 7.75-18.374 7.75z"
        fill="currentColor"
      />
    </svg>
  );
}

export default React.forwardRef(SvgProductBird);
